import { render } from "./CalendarView.vue?vue&type=template&id=728ce2b0&scoped=true"
import script from "./CalendarView.vue?vue&type=script&lang=js"
export * from "./CalendarView.vue?vue&type=script&lang=js"

import "./CalendarView.vue?vue&type=style&index=0&id=728ce2b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-728ce2b0"]])

export default __exports__